import React, { useEffect, useRef } from "react";
import { useFormikContext, useField } from "formik";
import DatePicker from "react-datepicker";
import { setMinutes, setHours } from "date-fns";
import { Input } from 'semantic-ui-react';
import moment from 'moment';

export const DateData = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  const datePickerRef = useRef(null);

  const handleOnKeyDown = event => {
    // if (event?.keyCode === 13 || event?.which === 13) {
    // datePickerRef.current.setOpen(true);
    // }
    // else 
    if (event?.keyCode === 9 || event?.which === 9) {
      datePickerRef.current.setOpen(false);
    }
  };

  useEffect(() => {
    if (props.tname) {
      setFieldValue(props.tname, field.value ? moment(field.value).format('YYYY-MM-DD HH:mm:ss') : null)
    }
  }, [])
  return (
    <DatePicker
      isClearable={props.disabled ? false : true}
      popperClassName="dateTime"
      {...field}
      {...props}
      selected={(field?.value && field?.value != '0000-00-00' && new Date(field?.value)) || null}
      onChange={(val) => {
        if (props.tname) {
          setFieldValue(props.tname, val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : null)
        }
        setFieldValue(field.name, val);
        props.onChangeExtra && props.onChangeExtra(val)
      }}
      preventOpenOnFocus={false}
      ref={datePickerRef}
      onKeyDown={handleOnKeyDown}
      customInput={<Input defaultValue={props.defaultValue} className="dateWidth" icon="calendar alternate outline" iconPosition="left" />}
    />
  );
};
